import { useThemeContext } from '#contexts/ThemeContext';
import { Box, Dialog, DialogContent, DialogTitle, IconButton, Typography } from '@material-ui/core';
import { CloseOutlined, InfoOutlined } from '@material-ui/icons';

interface DialogProps {
  open: boolean;
  helperText: string;
  setDialogState: any;
}

export const HelperDialog = ({ open, helperText = 'Helper Text', setDialogState }: DialogProps) => {
  const closeDialog = () => {
    setDialogState({
      open: false,
      helperText: ''
    });
  };
  const { iconButtons, answerHelperText } = useThemeContext();

  return (
    <Dialog open={open} fullWidth maxWidth='xs'>
      <DialogTitle style={{ padding: 0, height: 16 }}>
        <Box display='flex' justifyContent='flex-end'>
          <IconButton aria-label='close' onClick={closeDialog}>
            <CloseOutlined style={{ color: answerHelperText }} />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Box mt={1} mb={{ xs: 2, sm: 4 }}>
          <InfoOutlined style={{ fontSize: 54, color: iconButtons }} />
        </Box>
        <Box pl={2} mb={2}>
          <Typography
            style={{
              color: answerHelperText
            }}
            className='semiBold'
          >
            {helperText}
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
};
